import type { FreeTrial } from '../productsListing/types'

export enum FreeTrialsActionTypes {
  UPDATE_FREE_TRIALS_DIMENSION_ROW_QUANTITY = 'UPDATE_FREE_TRIALS_DIMENSION_ROW_QUANTITY',
  ADD_FREE_TRIALS_DIMENSION_ROW = 'ADD_FREE_TRIALS_DIMENSION_ROW',
  REMOVE_FREE_TRIALS_DIMENSION_ROW = 'REMOVE_FREE_TRIALS_DIMENSION_ROW',
  UPDATE_FREE_TRIALS_DIMENSION_ROW_ID = 'UPDATE_FREE_TRIALS_DIMENSION_ROW_ID',
  UPDATE_FREE_TRIALS_NUMBER_OF_DAYS = 'UPDATE_FREE_TRIALS_NUMBER_OF_DAYS',
  ADD_FREE_TRIALS_PRODUCT = 'ADD_FREE_TRIALS_PRODUCT',
  UPDATE_EULA_TYPE = 'UPDATE_EULA_TYPE',
  ADD_EULA_FILES = 'ADD_EULA_FILES',
  UPDATE_ON_REVIEW = 'UPDATE_ON_REVIEW',
}

export interface ProductDimensionFreeTrial {
  productDimensionId?: string
  freeTrial?: FreeTrial
}
export enum FileUploadType {
  EULA_FILES = 'EULA_FILES',
  PRODUCT_LOGO = 'PRODUCT_LOGO',
}
export enum FreeTrialStatus {
  FREE_TRIAL_CREATION_IN_PROGRESS = 'FREE_TRIAL_CREATION_IN_PROGRESS',
  FREE_TRIAL_CREATED = 'FREE_TRIAL_CREATED',
  FREE_TRIAL_DEACTIVATION_IN_PROGRESS = 'FREE_TRIAL_DEACTIVATION_IN_PROGRESS',
  FREE_TRIAL_DEACTIVATED = 'FREE_TRIAL_DEACTIVATED',
}
export interface FreeTrials {
  productId: string
  freeTrial: FreeTrial
  eulaType?: string
  eulaFile?: string[]
  selectedEulaFiles?: File[]
  productDimensions: ProductDimensionFreeTrial[]
  onReview?: boolean
}
export interface FreeTrialsState {
  [x: string]: FreeTrials
}
export const initialFreeTrialsState: FreeTrialsState = {}

export type deactivateFreeTrialParams = {
  labraFreeTrialId: string
  partnerId: string
  productId: string
  cloudMarketplace: string
  callBack?: () => void
}

export type FreeTrialsAction =
  | {
      type: FreeTrialsActionTypes.UPDATE_FREE_TRIALS_DIMENSION_ROW_QUANTITY
      payload: {
        productId: string
        index: number
        quantity: number
      }
    }
  | {
      type: FreeTrialsActionTypes.ADD_FREE_TRIALS_DIMENSION_ROW
      payload: string
    }
  | {
      type: FreeTrialsActionTypes.REMOVE_FREE_TRIALS_DIMENSION_ROW
      payload: { productId: string; index: number }
    }
  | {
      type: FreeTrialsActionTypes.UPDATE_FREE_TRIALS_DIMENSION_ROW_ID
      payload: { productId: string; index: number; id: string }
    }
  | {
      type: FreeTrialsActionTypes.UPDATE_FREE_TRIALS_NUMBER_OF_DAYS
      payload: { productId: string; numberOfDays: number }
    }
  | {
      type: FreeTrialsActionTypes.ADD_FREE_TRIALS_PRODUCT
      payload: string
    }
  | {
      type: FreeTrialsActionTypes.UPDATE_EULA_TYPE
      payload: { productId: string; eulaType: string }
    }
  | {
      type: FreeTrialsActionTypes.ADD_EULA_FILES
      payload: { productId: string; eulaFiles: string[] }
    }
  | {
      type: FreeTrialsActionTypes.UPDATE_ON_REVIEW
      payload: { productId: string; onReview: boolean }
    }
